import * as Sentry from "@sentry/nextjs";
import { redirect } from "next/navigation";
import { getErrorMessage } from "./utils";

export type ErrorMessageOptions = {
  message?: string;
  ctaText?: string;
  ctaAction?: "logout" | "reload" | "home" | "back";
};

/**
 * Handles server-side errors by capturing in Sentry and redirecting to error page
 */

export function handleServerError(
  error: Error | unknown,
  options?: ErrorMessageOptions,
): never {
  // Always capture server errors in Sentry
  Sentry.captureException(error, {
    tags: {
      location: "server",
    },
  });

  // Redirect to error page
  const message =
    options?.message ||
    getErrorMessage(error) ||
    "An unexpected error occurred. Please logout and try again.";
  const ctaText = options?.ctaText || "Logout";
  const ctaAction = options?.ctaAction || "logout";

  redirect(
    `/error-page?message=${encodeURIComponent(message)}&cta_text=${encodeURIComponent(ctaText)}&cta_action=${ctaAction}`,
  );
}
